import { render } from "./BuscarItensPedidoCompra.vue?vue&type=template&id=4cbb6f80&scoped=true&ts=true"
import script from "./BuscarItensPedidoCompra.vue?vue&type=script&lang=ts"
export * from "./BuscarItensPedidoCompra.vue?vue&type=script&lang=ts"

import "./BuscarItensPedidoCompra.vue?vue&type=style&index=0&id=4cbb6f80&scoped=true&lang=css"

import exportComponent from "D:\\Desenvolvimento\\NeoXApp\\NeoX.Frontend\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4cbb6f80"]])

export default __exports__